import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs'
import { POI } from '../models/POI';
import { Address } from '../models/Address';
import { BeachSite } from '../models/BeachSite';
import { Council, Region } from '../models/SiteGroups';

export type ZoomToSearchDataTypes = POI | Address | BeachSite | Region | Council | "CURRENT_LOCATION";

@Injectable({
    providedIn: "root"  // make this service as singleton service provided by root, no need to set providers in components that use this service
})
export class ZoomToSearchResultService {

    private _zoomData$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    public zoomToData = this._zoomData$.asObservable();
    

    setZoomToData(data: any) {
        this._zoomData$.next(data);
    }
}

